import React from 'react';
import { getComponentClasses } from '../../utils/app';

export interface Props {
    variations?: string[];
    children: React.ReactNode;
}

export const Ribbon = ({ variations = [], children }: Props) => (
    <div className={getComponentClasses('ribbon', variations)}>
        <div className="ribbon__text">{children}</div>
    </div>
);

export default Ribbon;
